import { importType } from '@angular/compiler/src/output/output_ast';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ReportsComponent } from './reports/reports.component'
import { AuditDashboardComponent } from './audit-dashboard/audit-dashboard.component'
import { AuthGuard } from '../../../../shared/_guards/auth.guard';

const routes: Routes = [
  { path: 'reports', component: ReportsComponent, canActivate: [AuthGuard] },
  { path: 'audit-dashboard', component: AuditDashboardComponent, canActivate: [AuthGuard] }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ReportsRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/components/admin/hca-admin/reports/reports-routing.module.ts